export const GAME_CONFIG = {
  canvas: {
    width: 540,
    height: 960,
  },
  storage: {
    bestTimeKey: 'defiende-pipis:best-time',
  },
  loading: {
    minDuration: 900,
  },
  barn: {
    centerX: 270,
    centerY: 592,
    radiusX: 218,
    radiusY: 310,
    fencePadding: 42,
  },
  chicken: {
    radius: 34,
    speedMin: 18,
    speedMax: 42,
    turnIntervalMin: 0.8,
    turnIntervalMax: 2.4,
    animationFrameDuration: 0.18,
  },
  egg: {
    radius: 26,
    hatchRadius: 48,
    duration: 6.8,
    warningTime: 2,
    pulseSpeed: 8,
  },
  fox: {
    radius: 42,
    scareRadius: 68,
    eatRadius: 44,
    spawnMargin: 62,
    fleeDuration: 0.3,
    animationFrameDuration: 0.1,
  },
  balance: {
    checkpointsSeconds: [0, 45, 90, 180, 360],
    foxSpawn: {
      intervalReductionPerMinute: 0.9,
      minInterval: 0.58,
    },
    foxSpeed: {
      increasePerMinute: 0.46,
      maxMultiplier: 3.25,
    },
    foxWave: {
      extraFoxChancePerMinute: 0.34,
      maxExtraFoxes: 3,
    },
    eggSpawn: {
      delayIncreasePerMinute: 0.45,
      maxMultiplier: 2.75,
    },
    eggDuration: {
      reductionPerMinute: 0.2,
      minDuration: 3.2,
    },
    maxFoxes: {
      increasePerMinute: 2,
    },
  },
  levels: {
    easy: {
      label: 'Fácil',
      description: 'Más gallinas, menos zorros y margen para respirar.',
      initialChickens: 5,
      firstFoxDelay: 2.65,
      firstEggDelay: 5.5,
      foxSpawnInterval: 3.45,
      eggSpawnInterval: 9.5,
      foxBaseSpeed: 112,
      maxFoxes: 2,
      maxFoxesCap: 7,
    },
    medium: {
      label: 'Medio',
      description: 'Un corral movido, con zorros entrando a buen ritmo.',
      initialChickens: 4,
      firstFoxDelay: 1.8,
      firstEggDelay: 7,
      foxSpawnInterval: 2.45,
      eggSpawnInterval: 12.5,
      foxBaseSpeed: 148,
      maxFoxes: 3,
      maxFoxesCap: 9,
    },
    hard: {
      label: 'Difícil',
      description: 'Pocas gallinas, zorros veloces y casi sin tregua.',
      initialChickens: 3,
      firstFoxDelay: 1.05,
      firstEggDelay: 8.8,
      foxSpawnInterval: 1.65,
      eggSpawnInterval: 16.5,
      foxBaseSpeed: 188,
      maxFoxes: 4,
      maxFoxesCap: 12,
    },
  },
  effects: {
    scareDuration: 0.36,
    hatchDuration: 0.5,
    dangerPulseDuration: 0.6,
    lostDuration: 0.62,
    missionDuration: 1.1,
    recordDuration: 1.25,
    gameOverDuration: 0.95,
    spawnDuration: 0.55,
    speedTrailDuration: 0.22,
    maxParticles: 34,
  },
  feedback: {
    soundEnabled: true,
    vibrationEnabled: true,
    volume: 0.16,
    sounds: {
      scare: { frequency: 440, endFrequency: 220, duration: 0.09, type: 'square' },
      hatch: { frequency: 660, endFrequency: 990, duration: 0.14, type: 'sine' },
      lost: { frequency: 220, endFrequency: 120, duration: 0.18, type: 'sawtooth' },
      mission: { frequency: 523, endFrequency: 784, duration: 0.2, type: 'triangle' },
      record: { frequency: 784, endFrequency: 1175, duration: 0.24, type: 'sine' },
      gameOver: { frequency: 196, endFrequency: 82, duration: 0.28, type: 'triangle' },
    },
    vibrations: {
      scare: [18],
      hatch: [12, 25, 18],
      lost: [45],
      mission: [24, 35, 24],
      record: [20, 30, 20, 30, 30],
      gameOver: [55, 35, 80],
    },
  },
};
